module.exports = __webpack_public_path__ + "img/quality.ce7372c.jpg";